Vue.component('url', {
    props: ['current', 'name'],

    data () {
        return {
            view: 'buttons',

            url: ''
        };
    },

    mounted () {
        if (this.current === 'no-url') {
            this.view = 'edit';
        } else {
            this.url = this.current;
        }
    },

    methods: {
        edit () {
            this.view = 'edit';
        }
    },

    template: `
        <div>
            <div class="clearfix"></div>
            
            <div class="btn-group" v-if="view == 'buttons'">
                <a target="_blank" :href="url" class="btn btn-success">{{ name == 'linkedin' ? 'Send Message' : 'Visit' }}</a>
                <button class="btn btn-primary" @click="edit">Edit Link</button>
            </div>
            
            <input v-if="view == 'edit'" type="text" :name="name" v-model="url" class="form-control">
        </div>
    `
});